import { render, staticRenderFns } from "./productReviewsB2b.vue?vue&type=template&id=68633bc8&scoped=true&"
import script from "./productReviewsB2b.vue?vue&type=script&lang=js&"
export * from "./productReviewsB2b.vue?vue&type=script&lang=js&"
import style0 from "./productReviewsB2b.vue?vue&type=style&index=0&id=68633bc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68633bc8",
  null
  
)

export default component.exports